export default __webpack_public_path__ + "static/media/1543.54c1c97e.png";